export default __webpack_public_path__ + "static/media/sun.4fd3bbbc.svg";